export const EVENT_NAME = {
  CANCEL: "My Bets CTA Clicked",
  SUBMIT: "Bet Cancel Submitted",
  ERROR: "Bet Cancel Error",
  SUCCESS: "Bet Cancel Successful",
  KEEP_BET: "Cancel Bet CTA Clicked",
  MODAL_CLOSED: "Cancel Bet Modal Closed"
};
